<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  
  name: 'App',
  computed: {
    path() {
      this.$route.path
    }
  }
}
</script>

<style>
#app {
  font-family: 'AlibabaPuHuiTi';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue